"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const lodash_1 = require("lodash");
const buildHttpsRequest_1 = __importDefault(require("./buildHttpsRequest"));
const getValueByPathFromUnknown_1 = __importDefault(require("./getValueByPathFromUnknown"));
const mapResponse = ({ outputFields, response }) => {
    const result = {};
    Object.keys(outputFields).forEach((key) => {
        let dataObtained = (0, lodash_1.get)(response, outputFields[key].path, undefined);
        if (dataObtained) {
            switch (outputFields[key].type) {
                case 'number':
                    dataObtained = (0, lodash_1.toNumber)(dataObtained);
                    break;
                case 'string':
                    if (!(0, lodash_1.isString)(dataObtained)) {
                        dataObtained = (0, lodash_1.toString)(dataObtained);
                    }
                    break;
                case 'object':
                    break;
                default:
                    throw new Error(`Output field type is not valid: ${outputFields[key].type}`);
            }
        }
        result[key] = dataObtained;
    });
    return result;
};
class ErrorResponse extends Error {
    constructor(params) {
        var _a;
        super('Error Response');
        this.message = ((_a = params.response) === null || _a === void 0 ? void 0 : _a.message) || 'No message';
        this.response = params.response;
        this.requestConfig = params.requestConfig;
    }
}
const processAPIRequest = async ({ baseDefinition, baseInputValues, baseInputFields, endPoint, inputFields, outputFields = {}, inputValues, requestType, requestDefinition = {}, }) => {
    const requestConfig = (0, buildHttpsRequest_1.default)({
        baseDefinition,
        baseInputValues,
        baseInputFields,
        endPoint,
        inputFields,
        inputValues,
        requestType,
        requestDefinition,
    });
    try {
        const response = await axios_1.default.request(requestConfig);
        return {
            response: (outputFields && mapResponse({ outputFields, response })) || {},
            rawResponse: response,
            requestConfig,
        };
    }
    catch (error) {
        const errorMessage = (0, getValueByPathFromUnknown_1.default)(error, ['message']);
        throw new ErrorResponse({
            message: `${errorMessage}`,
            requestConfig,
        });
    }
};
exports.default = processAPIRequest;
